import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/tarea`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const postTask = async (tarea, novedadId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${novedadId}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(tarea),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchTask = async (novedadId, tarea) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${novedadId}/${tarea.id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(tarea),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchTasks = async (tareas) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`centralizer`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ tasks: tareas }),
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchTaskCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("categories"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
